module.exports = __webpack_public_path__ + "p1_img5.jpg?60a7bf0a32b4e159f53a301140452de2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p1/p1_img5.jpg
// module id = 107
// module chunks = 0